import React from 'react';
import { Gift } from 'lucide-react';
const BONUSES = [{
  id: 1,
  title: 'BONO 1 – Frases Exactas para Momentos Críticos del Aula',
  desc: 'Scripts listos para usar cuando no hay tiempo para pensar.',
  image: 'https://cdn.magicpatterns.com/uploads/iLSaA1F9zbTqPsX7uT8yQ4/mock_up_1-removebg-preview.png'
}, {
  id: 2,
  title: 'BONO 2 – Mapa Rápido de Intervención Docente',
  desc: 'Una guía tipo "GPS" que te dice qué hacer según lo que esté pasando.',
  image: 'https://cdn.magicpatterns.com/uploads/3RkB5jLBCGnTjuypFjmdzX/744a3e2b-4493-4c1b-9d5a-94f8954210bc-removebg-preview.png'
}, {
  id: 3,
  title: 'BONO 3 – Rutinas de 5 Minutos para Ordenar el Aula',
  desc: 'Secuencias breves para inicio de clase, recreo, evaluaciones y cierre.',
  image: 'https://cdn.magicpatterns.com/uploads/hxMSvQ1dDbGqokpaHszFRV/955bff3b-5e6d-43c3-8e8c-b890d7490a33-removebg-preview.png'
}];
export function BonusSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-white to-gray-50 py-16 md:py-24" data-id="element-22">
      <div className="mx-auto max-w-6xl px-4" data-id="element-23">
        <div className="mb-12 text-center" data-id="element-24">
          <div className="inline-flex items-center gap-2 rounded-full bg-red-100 px-4 py-2 text-sm font-bold text-red-600 mb-4" data-id="element-25">
            <Gift className="h-4 w-4" data-id="element-26" />
            <span data-id="element-27">SOLO POR HOY</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 md:text-5xl" data-id="element-28">
            🎁 BONOS INCLUIDOS — GRATIS HOY
          </h2>
          <p className="mt-4 text-xl text-gray-600" data-id="element-29">
            Al adquirir el MEGA KIT hoy, te llevás estos 3 regalos exclusivos:
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3" data-id="element-30">
          {BONUSES.map(bonus => <div key={bonus.id} className="flex flex-col items-center text-center cursor-pointer group" onClick={scrollToCompra} data-id="element-31">
              {/* Bonus Image */}
              <div className="mb-6 transition-transform duration-300 group-hover:scale-105" data-id="element-32">
                <img src={bonus.image} alt={bonus.title} className="h-64 md:h-80 w-auto object-contain drop-shadow-xl" data-id="element-33" />
              </div>

              {/* Bonus Info */}
              <div className="flex-1" data-id="element-34">
                <h3 className="mb-2 text-lg md:text-xl font-bold text-gray-900" data-id="element-35">
                  {bonus.title}
                </h3>
                <p className="text-gray-600" data-id="element-36">{bonus.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-37">
          <p className="text-xl font-bold text-gray-900" data-id="element-38">
            👉 Para que nunca te quedes sin saber qué decir ni qué hacer.
          </p>
        </div>
      </div>
    </section>;
}